import { __decorate, __metadata } from "tslib";
import { inject, injectable } from "inversify";
import { LocalizationContext } from "../context";
let LibraryLocaleAdapter = class LibraryLocaleAdapter {
    registerListeners() {
        this.localizationContext.value$.subscribe(x => this.onLocaleChange(x.currentLocale));
    }
};
__decorate([
    inject(LocalizationContext),
    __metadata("design:type", LocalizationContext)
], LibraryLocaleAdapter.prototype, "localizationContext", void 0);
LibraryLocaleAdapter = __decorate([
    injectable()
], LibraryLocaleAdapter);
export { LibraryLocaleAdapter };
//# sourceMappingURL=LibraryLocaleAdapter.js.map